import ThirdStep from './ThirdStep'

export default ThirdStep
